import { useEffect, useState } from 'react';

import HookSelectFormControl from '../HookSelectFormControl';

import ParticipantsService from 'services/ParticipantsService';

import useResources from 'hooks/useResources';

const HookApproximateAgeFormControl = (props: any) => {
    const [ages, setAges] = useState([] as any[]);

    const { t } = useResources(['approx-age']);
    const { t: t1 } = useResources();

    useEffect(() => {
        setAges(ParticipantsService.getApproximateAges(t));
    }, []);

    return (
        <HookSelectFormControl
            {...props}
            items={[...ages.map((a) => ({ value: a.age, title: a.range }))]}
            addEmptyItem={true}
            emptyItemTitle={t1(`ui.selectPlaceHolder.age`)}
        />
    );
};

export default HookApproximateAgeFormControl;
